// extracted by mini-css-extract-plugin
export default {"container":"Sidebar_container__HnbGu","logo":"Sidebar_logo__oKDIf","menu":"Sidebar_menu__lcumH","item":"Sidebar_item__Q94XX"};